/* eslint-disable indent */
import { useState, useLayoutEffect } from 'react'

import { toast } from 'react-toastify'
import Container from 'react-bootstrap/Container'

import Sidebar from '../../components/Sidebar/Sidebar'
import NavTop from '../../components/NavTop'
import getMenu from './menu'
import { useAuth } from '../../hooks/AuthContext'
import api from '../../services/api'
import { useLoading } from '../../hooks/LoadingContext'

function Citizen({ children, backgroundColor = '#E5E5E5', pageName }) {
  const { authData, signOut } = useAuth()
  const role = authData.role ? authData.role : 'public'
  const [userData, setUserData] = useState({})

  const { setIsLoading } = useLoading()

  const loadProfile = async () => {
    try {
      let data
      switch (role) {
        case 'company':
          setIsLoading(true)
          ;({ data } = await api.get(`/company/companies`))
          setUserData(data)
          break
        case 'manager':
          setIsLoading(true)
          ;({ data } = await api.get(`/delivery-manager/delivery-managers`))
          setUserData(data)
          break
        case 'attendant':
          setIsLoading(true)
          ;({ data } = await api.get(`/attendant/attendants`))
          setUserData(data)
          break
        case 'admin':
          setIsLoading(true)
          ;({ data } = await api.get(`/admin/admins/${authData.id}?profilePicture=true`))
          setUserData({
            ...data,
            name: data.name,
            sector: data.sector,
            account_validated: data.account_validated,
            profile_picture: data.user.profilePicture,
            email: data.user.email,
          })
          break
        case 'public':
          throw new Error('Public profile not implemented')
        default:
          throw new Error('Invalid role')
      }
    } catch (error) {
      console.log(error)
    }
    setIsLoading(false)
  }

  useLayoutEffect(() => {
    async function loadData() {
      try {
        await loadProfile()
      } catch {
        signOut()
        toast.error('Falha ao buscar o perfil do usuário :(\nFaça login novamente.')
      }
    }

    loadData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [signOut])

  const menu = getMenu()
  const [toggled, setToggled] = useState(false)
  const [collapsed, setCollapsed] = useState(false)

  const handleCollapsedChange = (checked) => {
    setCollapsed(checked)
  }

  const handleToggleSidebar = (value) => {
    setToggled(value)
  }

  return (
    <div
      style={{
        display: 'flex',
      }}
    >
      <Sidebar
        collapsed={collapsed}
        handleToggleSidebar={handleToggleSidebar}
        toggled={toggled}
        menu={menu[role]}
        user={userData}
      />
      <Container
        style={{
          backgroundColor,
          overflowX: 'hidden',
        }}
        fluid
      >
        <NavTop
          user={userData}
          handleCollapsedChange={handleCollapsedChange}
          handleToggleSidebar={handleToggleSidebar}
          toggled={toggled}
          collapsed={collapsed}
          pageName={pageName}
        />
        <div
          style={{
            paddingTop: '10px',
          }}
        >
          {children}
        </div>
      </Container>
    </div>
  )
}

export default Citizen
